<template>
  <div>巡检记录</div>
</template>

<script>
export default {
  name: 'InspectRecordsInfo',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
